import { Component, Inject, OnInit } from '@angular/core';
import { addDays, isBefore, startOfDay } from 'date-fns';
import { DialogRef } from '../../dialog/dialog-ref';
import { DATA, DIALOG } from '../../dialog/dialog.service';

export interface MoveAssignmentsDialogResult {
  date: Date;
}

export interface MoveAssignmentsDialogData {
  date: Date;
}


@Component({
  selector: 'app-move-assignments-dialog',
  templateUrl: './move-assignments-dialog.component.html',
  styleUrls: ['./move-assignments-dialog.component.scss']
})
export class MoveAssignmentsDialogComponent {

  date: Date;

  constructor(@Inject(DIALOG) private dialog: DialogRef, @Inject(DATA) data: MoveAssignmentsDialogData) {
    this.date = data.date ?? new Date();
  }

  cancel() {
    this.dialog.close();
  }

  accept() {
    this.dialog.close({date: this.date} as MoveAssignmentsDialogResult);
  }
}
